import router from '../router'
import store from '../store'
import { createWt, addSteps } from './wt'
import {
    wtAccepted,
    wtConflicted,
    wtLabelGroups,
    wtPromoGroups
} from './wtData'

export const tour = createWt()
let noPromoAcceptPermissions =
    store.getters.isShopUser && !store.getters.isPromoEditPermission

const saveSelectedLabels = store.getters.getSelectedLabelGroups

const steps = [
    {
        id: 1,
        title: 'Samouczek',
        text:
            'Witaj w samouczku nowego Panelu Detalisty EuroPlatform! W kolejnych krokach przeprowadzimy Cię przez najważniejsze funkcje platformy.',
        attachTo: {
            element: false,
            on: 'auto'
        }
    },
    {
        id: 2,
        title: 'Pulpit',
        text:
            'Obecnie znajdujesz się na pulpicie. Znajdziesz tu podsumowanie swojej sprzedaży i aktywności w EuroPlatform.',
        attachTo: {
            element: '[data-walk="1-1"]',
            on: 'bottom'
        }
    },
    {
        id: 3,
        title: 'Powiadomienia i Ustawienia',
        text:
            'W tej sekcji znajdziesz przydatne informacje, takie jak: <ul><li>stan połączeń Twoich urządzeń fiskalnych</li><li>powiadomienia, czyli wiadomości, które chcemy Ci przekazać</li><li>Twoje dane, dokumenty, zgody marketingowe</li></ul>',
        attachTo: {
            element: '[data-walk="1-2"]',
            on: 'bottom'
        }
    },
    {
        id: 4,
        title: 'Promocje',
        text: 'Teraz przejdź do zarządzania promocjami.',
        attachTo: {
            element: (() => {
                let element
                if (window.innerWidth < 992) {
                    element = '.m-userControl #mobile-promos-icon'
                } else {
                    element = '.main-nav-list .nav-item:nth-of-type(2)'
                }
                return element
            })(),
            on: 'bottom'
        },
        actionNext: () => {
            router.push({ name: 'promo-list' })
        }
    },
    {
        id: 5,
        title: 'Promocje',
        text:
            'Znajdujesz się obecnie w sekcji służącej do zarządzania promocjami.',
        attachTo: {
            element: false,
            on: 'auto'
        },
        actionPrev: () => {
            router.push({ name: 'dashboard' })
        },
        actionNext: () => {
            const btnFilter = document.querySelector('.btn-filter')

            btnFilter.style.transitionDuration = '0s'
            btnFilter.style.animationDuration = '0s'
            btnFilter.scrollIntoView()

            setTimeout(() => {
                btnFilter.style.transitionDuration = '0.4s'
                btnFilter.style.animationDuration = '1s'
            }, 1000)
        }
    },
    {
        id: 6,
        title: 'Filtry',
        text:
            'Dzięki filtrom w łatwy sposób zawęzisz listę promocji do tych, które interesują Cię najbardziej. Filtruj po statusie promocji, Organizatorach lub typach promocji. Możesz zapamiętywać filtry, aby mieć do nich szybszy dostęp w przyszłości!',
        attachTo: {
            element: window.innerWidth < 768 ? '.btn-filter' : '.filter-wrap',
            on: 'auto'
        }
    },
    {
        id: 7,
        title: 'Sortowanie',
        text:
            'Listę promocji możesz sortować na różne sposoby. Wybierz, czy kolejność wyświetlania wyników ma być malejąca czy rosnąca.',
        attachTo: {
            element: '.c-settings-filters .c-settings-select',
            on: 'auto'
        },
        actionNext: () => {
            if (noPromoAcceptPermissions) {
                store.commit('SET_SELECTED_LABELGROUPS', wtLabelGroups)
                store.dispatch('openModal', {
                    component: 'ModalLabels'
                })
            }
        }
    },
    {
        id: 8,
        title: 'Aktywacja promocji w grupie zamkniętej',
        text:
            'Aktywacja promocji w grupie zamkniętej (oznaczonej symbolem kłódki) odbywa się przez zaznaczenie pola „Dodaj grupę do aktywacji” w prawym górnym rogu. Aktywacja pojedynczej promocji z grupy zamkniętej skutkuje aktywacją całej grupy. Jeśli chcesz zapoznać się ze szczegółami promocji, kliknij na jej grafikę.',
        attachTo: {
            element: '.m-promoGroup.all',
            on: 'auto'
        },
        actionNext: () => {
            wtPromoGroups[0].selectWholeGroup = true
            wtPromoGroups[0].selectedPromoIds = [1, 2]

            store.commit('SELECT_PROMOGROUP', [wtPromoGroups[0]])
        }
    },
    {
        id: 9,
        title: 'Aktywacja promocji w grupie otwartej',
        text:
            'Możesz aktywować zbiorczo wszystkie promocje w grupie otwartej, klikając w „Dodaj grupę do aktywacji” w prawym górnym rogu. Masz również możliwość aktywacji pojedynczej promocji w ramach tej grupy poprzez kliknięcie w „Dodaj do aktywacji” przy danej promocji. Jeśli chcesz zapoznać się ze szczegółami promocji, kliknij na jej grafikę.',
        attachTo: {
            element: '.m-promoGroup.any',
            on: 'auto'
        },
        actionPrev: () => {
            wtPromoGroups[0].selectWholeGroup = false
            wtPromoGroups[0].selectedPromoIds = []

            store.commit('SELECT_PROMOGROUP', [])
        },
        actionNext: () => {
            wtPromoGroups[1].selectWholeGroup = true
            wtPromoGroups[1].selectedPromoIds = [3, 4]

            store.commit('SELECT_PROMOGROUP', wtPromoGroups)
        }
    },
    {
        id: 10,
        title: 'Aktywacja promocji',
        text: 'Naciśnij „Przejdź do aktywacji”, aby kontynuować.',
        attachTo: {
            element: '.selected-header .container',
            on: 'auto'
        },
        actionPrev: () => {
            wtPromoGroups[1].selectWholeGroup = false
            wtPromoGroups[1].selectedPromoIds = []

            store.commit('SELECT_PROMOGROUP', wtPromoGroups)
        },
        actionNext: () => {
            const button = document.querySelector(
                '.walkthrough .selected-actions button:nth-of-type(2)'
            )
            button.click()
            setTimeout(() => {
                const modal = document.querySelector('.modal--accept')
                modal.style.display = 'block'
                const modalBackdrop = document.querySelector('.modal-backdrop')
                modalBackdrop.style.display = 'block'
                store.commit('SET_WALKTHROUGH_MODAL_PROMO_ACCEPT_STEP', 1)
            }, 0)
        }
    },
    {
        id: 11,
        title: 'Aktywacja promocji',
        text:
            'Zapoznaj się z podsumowaniem wybranych do aktywacji promocji. Kliknij „Pokaż promocje”, następnie „Szczegóły promocji”, aby modyfikować parametry oferty.',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            const modal = document.querySelector('.modal--accept')
            modal.style.display = 'none'
            const modalBackdrop = document.querySelector('.modal-backdrop')
            modalBackdrop.style.display = 'none'
        },
        actionNext: () => {
            const showPromosBtn = document.querySelector(
                '.m-modalPromoAccept__showPromosBtn'
            )
            showPromosBtn.click()

            setTimeout(() => {
                const showPromoDetailsBtn = document.querySelector(
                    '.m-promoPreviewSmallDetails__showPromoDetailsBtn'
                )
                showPromoDetailsBtn.click()
            }, 0)
        }
    },
    {
        id: 12,
        title: 'Aktywacja promocji',
        text:
            'Na tym etapie możesz dokonać zmiany ceny promocyjnej - nie przekraczając maksymalnej ceny produktu w promocji. W tym kroku masz również możliwość wyboru sklepów, w których ma odbyć się dana promocja.',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            const showPromosBtn = document.querySelector(
                '.m-modalPromoAccept__showPromosBtn'
            )
            showPromosBtn.click()
        },
        actionNext: () => {
            store.commit('SET_SUBSCRIPTIONS_PROGRESS', {
                processed: 4,
                total: 4
            })

            store.commit('SET_PROCESSED_SUBSCRIPTIONS_TOTAL', 4)

            const gotToActivatePromosBtn = document.querySelector(
                '.walkthrough .btn-activate-promos'
            )
            gotToActivatePromosBtn.click()

            setTimeout(() => {
                store.commit('SET_PROCESSED_SUBSCRIPTIONS', {
                    total: 4,
                    accepted: {
                        promos: wtAccepted,
                        pagination: { totalRecords: 2 }
                    },
                    error: {
                        promos: wtConflicted,
                        pagination: { totalRecords: 2 }
                    }
                })

                store.commit('SET_WALKTHROUGH_MODAL_PROMO_ACCEPT_STEP', 3)
            }, 1000)
        }
    },
    {
        id: 13,
        title: 'Potwierdzenie aktywacji promocji',
        text:
            'W kolejnym kroku potwierdzona zostanie aktywacja promocji. Jeśli występuje problem z promocją, system poinformuje o braku możliwości aktywacji promocji do czasu jego rozwiązania.',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            store.commit('SET_WALKTHROUGH_MODAL_PROMO_ACCEPT_STEP', 1)

            setTimeout(() => {
                const showPromoDetailsBtn = document.querySelector(
                    '.m-promoPreviewSmallDetails__showPromoDetailsBtn'
                )
                showPromoDetailsBtn.click()
            }, 0)
        }
    },
    {
        id: 14,
        title: 'Pamiętaj o cenówkach',
        text:
            'Możesz w łatwy sposób wygenerować cenówki do aktywowanych promocji. Wystarczy, że klikniesz przycisk „Generuj wybrane cenówki” i uzupełnisz (jeśli chcesz) ceny poza promocją.',
        attachTo: {
            element: '.btn-download-labels',
            on: 'auto'
        },
        actionNext: () => {
            const button = document.querySelector(
                '.walkthrough .btn-download-labels'
            )
            button.click()

            setTimeout(() => {
                store.commit('SET_WALKTHROUGH_MODAL_LABELS_STEP', 1)
                setTimeout(() => {
                    const showPromoDetailsBtn = document.querySelector(
                        '.m-promoPreviewSmallDetails__showPromoDetailsBtn'
                    )
                    showPromoDetailsBtn.click()
                })
            }, 0)
        }
    },
    {
        id: 15,
        title: 'Generowanie cenówek',
        text:
            'Przy generowaniu cenówki możesz uzupełnić cenę poza promocją. Po kliknięciu „Dostosuj ceny poza promocją” określ ceny towarów dla wszystkich sklepów zbiorczo lub indywidualnie dla każdego sklepu.',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            if (noPromoAcceptPermissions) {
                store.dispatch('toggleModal', false)
            } else {
                if (router.currentRoute.name !== 'promo-list') {
                    router.push({ name: 'promo-list' })
                }
                store.dispatch('openModal', {
                    component: 'ModalPromoAccept',
                    classes: 'modal--accept'
                })
                store.commit('SET_PROCESSED_SUBSCRIPTIONS', {
                    total: 4,
                    accepted: {
                        promos: wtAccepted,
                        pagination: { totalRecords: 2 }
                    },
                    error: {
                        promos: wtConflicted,
                        pagination: { totalRecords: 2 }
                    }
                })
                store.commit('SET_WALKTHROUGH_MODAL_PROMO_ACCEPT_STEP', 3)
            }
        },
        actionNext: () => {
            const button = document.querySelector(
                '.walkthrough .btn-generate-labels'
            )
            store.commit('SET_WALKTHROUGH_MODAL_LABELS_STEP', 3)
            button.click()
        }
    },
    {
        id: 16,
        title: 'Generowanie cenówek',
        text:
            'Określ, jaki materiał chcesz wygenerować – cenówkę lub plakat. Arkusz możesz pobrać na dysk i wydrukować lub wysłać na wskazany adres mailowy – np. kierownika sklepu. Pamiętaj o drukowaniu cenówek przy każdej aktywacji promocji. Bez nich klient nie dowie się o prowadzonej promocji!',
        attachTo: {
            element: '.modal-content',
            on: 'auto'
        },
        actionPrev: () => {
            store.commit('SET_WALKTHROUGH_MODAL_LABELS_STEP', 1)
            setTimeout(() => {
                const showPromoDetailsBtn = document.querySelector(
                    '.m-promoPreviewSmallDetails__showPromoDetailsBtn'
                )
                showPromoDetailsBtn.click()
            }, 0)
        },
        actionNext: () => {
            store.dispatch('toggleModal', false)
            tour.complete()
        }
    }
]

addSteps(tour, steps)

tour.on('start', function() {
    tour.steps = []
    let filterSteps = []
    if (store.getters.isShopUser && !store.getters.isPromoEditPermission) {
        filterSteps = [1, 2, 3, 4, 5, 6, 7, 15, 16]
    }
    addSteps(tour, steps, filterSteps)
    noPromoAcceptPermissions =
        store.getters.isShopUser && !store.getters.isPromoEditPermission

    if (router.currentRoute.name !== 'dashboard') {
        router.push({ name: 'dashboard' })
    }
    document.body.classList.add('walkthrough')
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'auto'
    store.dispatch('setWalkthroughActive', true)
    store.dispatch('clearSelectedPromoGroups')
    store.commit('SET_SELECTED_LABELGROUPS', [])
})

tour.on('show', function() {
    document.body.classList.add('walkthrough')
    store.dispatch('setWalkthroughActive', true)
})

const cancelEvents = ['close', 'cancel', 'complete']
cancelEvents.forEach(event => {
    return tour.on(event, () => {
        document.body.classList.remove('walkthrough')
        document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth'
        store.dispatch('setWalkthroughActive', false)
        store.dispatch('clearSelectedPromoGroups')
        store.commit('SET_SELECTED_LABELGROUPS', [])
        store.commit('SET_SELECTED_LABELGROUPS', saveSelectedLabels)

        window.scrollTo(0, 0)

        if (router.currentRoute.name !== 'dashboard') {
            if (router.currentRoute.name !== 'promo-list') {
                router.push({ name: 'promo-list' })
            } else {
                store.dispatch('loadPromoGroups')
            }
        }
    })
})

const closeEvents = ['cancel']
closeEvents.forEach(event =>
    tour.on(event, () => {
        store.dispatch('toggleModal', false)
    })
)
